<template>
  <div class="sf-collected-product__skeleton-loader">
    <SkeletonLoader height="26px" margin="0 0 16px" />
    <div class="grid" style="grid-column-gap: 16px">
      <SkeletonLoader class="col-7" height="198px" />
      <div class="col-5" >
        <SkeletonLoader height="24px" width="60px" margin="0 0 16px" />
        <SkeletonLoader height="50px" />
        <SkeletonLoader height="30px" margin="78px 0 0" />
      </div>
    </div>
    <SkeletonLoader height="26px" width="350px" margin="16px 0 0" />
  </div>
</template>

<script>
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default {
  components: { SkeletonLoader },
}
</script>

<style lang="scss" scoped>
.sf-collected-product {
  &__skeleton-loader {
    max-width: 510px;
  }
}
</style>
